import { Component, HostListener, OnInit, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { SwUpdate } from "@angular/service-worker";
import { ViewportWidthService } from "@helix/ng-mat-theme";
import mapboxgl from "mapbox-gl";
import { environment } from "src/environments/environment";
import { AuthService } from "./core/services/auth.service";
import { IndexedDBService } from "./shared/services/indexed-db/indexed-db.service";
import { ReleaseNotesService } from "./shared/services/release-notes/release-notes.service";

@Component({
  selector: "igv-app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private swUpdate = inject(SwUpdate);
  private authService = inject(AuthService);
  private releaseNotesService = inject(ReleaseNotesService);
  private indexDbService = inject(IndexedDBService);
  private readonly viewportWidthService = inject(ViewportWidthService);

  /**
   * Handles the beforeunload event triggered when the user leaves or refreshes the page.
   * This method logs the user out.
   */
  @HostListener("window:beforeunload", ["$event"])
  handleBeforeUnload(event: Event): void {
    this.authService.logout();
  }

  ngOnInit(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(event => {
        console.debug("serviceWorker update type: " + event?.type);

        if (event?.type === "VERSION_READY") {
          // only display prompt if on main map page.
          const currentUrl = window.location.href;
          if (currentUrl.includes("map")) {
            this.authService.storeToken();
            const result = this.releaseNotesService.openAppVersionDialog();
            result.subscribe((dialogResult: boolean) => {
              if (dialogResult) {
                this.indexDbService.clearIGVDataTables();
                this.indexDbService.populateIGVMetaData();
                window.location.reload();
              }
            });
          }
        }
      });
    }
    // (mapbox as any).accessToken = environment.mapboxAccessToken;
    mapboxgl.accessToken = environment.mapboxAccessToken;
  }
}
